import { SenderDetailsRow } from "@/routes/AccountSettings/SenderDetails/SenderDetails.types";
import { Audience, GetAudienceResponse } from "@/types/api/audience";
import { RootLoader } from "@/types/RootLoader";
import { fetchApi } from "@tiny/utils";
import { useTheme } from "@mui/material";
import React from "react";
import {
  useNavigate,
  useRouteLoaderData,
  useSearchParams,
} from "react-router-dom";

const useTinyCampaignBuilder = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const { senderDetails } = (useRouteLoaderData("main") as {
    senderDetails: SenderDetailsRow;
  }) || {
    senderDetails: {},
  };
  const [audiences, setAudiences] = React.useState<Audience[]>([]);
  const { accountInfo } = useRouteLoaderData("root") as RootLoader;

  const fetchAudiences = async () => {
    const response = await fetchApi<{ audiences: Audience[] }>(
      "/customerservice/segment?sort=name,asc",
      {
        method: "get",
      }
    );
    setAudiences(response?.audiences);
  };

  const exitWithoutSaving = () => {
    navigate(-1);
  };

  React.useEffect(() => {
    fetchAudiences();
  }, []);

  return {
    config: {
      theme,
      campaignId: searchParams.get("id") ?? "",
      senderDetails,
      audiences,
      exitWithoutSaving,
      accountId: accountInfo?.id,
    },
  };
};

export default useTinyCampaignBuilder;
